export default {
    search: 'Trend selection',
    selection:
    "You don't have selected any trend|You have selected 1 trend | You have selected {count} trends"
}
